import { i18nVersion } from "../i18n";

export const APP_VERSION: string = i18nVersion;

export const STORAGE_KEYS = {
  USER: "user",
  ORG: "organization",
  // legacy notification-check key: no longer written, still removed at sign-out
  LAST_NOTI_CHECK: "last_notification_check_date",
  // one key per user and organization, so the sweep matches on the prefix
  NOTI_CHECK_PREFIX: "noti_check_",
  // one key per organization, so the sweep matches on the prefix rather than an exact name
  ECO_EFF_FILTER_PREFIX: "ECO_EFF_DASHBOARD_FILTER_V2",
  SESSION_SCOPE: "session_scope",
  BROWSER_SESSION_COOKIE: "browser_session",
  // legacy Remember Me flag: read once at startup, then removed
  LEGACY_REMEMBER_ME: "rememberMe",
};

// Partner SSO landing page (/auth/sso). Off by default — set REACT_APP_ENABLE_SSO=true to register the route.
export const IS_SSO_ENABLED: boolean = process.env.REACT_APP_ENABLE_SSO === "true";

export const LOGO_IMG_SRC = "/img/login/CarbonCalLogoLong.svg";
export const LOGO_STACKED_IMG_SRC = "/img/carboncal-logo-stacked.svg";

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// --- 1. Constants (แยกค่าคงที่ออกมาเพื่อง่ายต่อการแก้ไข) ---
export const AUTOPLAY_INTERVAL_MS = 3000;
export const SLIDE_TRANSITION_MS = 700;
export const SUPPORT_EMAIL = "carboncal-support@locarb.green";
export const COMPANY_WEBSITE = "https://locarb.green/";

// cheapest plan with goal setting in the backend tier seed; a plan rename in AM needs this changed too
export const GOAL_SETTING_MIN_PLAN = "Starter";
